<template>
  <v-app class="futuristic-app">

    <v-app-bar app flat height="74" class="layanan-header">
      <div class="header-inner">
        <v-btn icon class="back-btn" @click="$router.back()" aria-label="Kembali">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <div class="header-brand">
          <div class="brand-mark">
            <img src="/images/icon2.png" width="40" />
          </div>

          <div class="brand-copy d-block d-sm-none d-lg-block">
            <div class="brand-name">BONDOWOSO <span>BERKAH</span></div>
            <div class="brand-tagline">Berkualitas, Akseleratif dan Holistik</div>
          </div>
        </div>

        <v-spacer />

        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          placeholder="Cari potensi desa..."
          solo
          flat
          rounded
          clearable
          hide-details
          background-color="#f1f6f5"
          class="header-search mr-3 d-none d-sm-flex"
        />

        <div class="header-info d-none d-sm-flex">
          <div class="header-info-icon">
            <v-icon size="18" color="#018c74"> mdi-database-marker </v-icon>
          </div>

          <div>
            <div class="header-info-title">Potensi Desa</div>
            <div class="header-info-subtitle">{{ $route.query.desa || "Semua Desa" }} · Kec. {{ $route.query.nama || "Bondowoso" }}</div>
          </div>
        </div>
      </div>
    </v-app-bar>

    <v-main class="main-area">
      <v-container
        class="py-12 content-layer"
        style="max-width: 1200px; position: relative; z-index: 5"
      >
        <div class="d-flex align-center mb-8 px-2">
          <div class="line-decorator-gold mr-4"></div>
          <h2 class="black--text text-overline letter-spacing-4">
            HASIL_PEMETAAN_ASET_WILAYAH
          </h2>
        </div>

        <v-slide-y-transition>
          <v-alert
            v-if="$route.query.desa"
            border="left"
            color="#018c74"
            dark
            dense
            class="glass-alert mb-8 px-6"
          >
            <v-icon left small color="#CFA22D">mdi-filter-check</v-icon>
            <span class="text-caption black letter-spacing-1">
              Menampilkan data potensi untuk wilayah:
              <strong>{{ $route.query.desa.toUpperCase() }}</strong>
            </span>
          </v-alert>
        </v-slide-y-transition>

        <v-row v-if="filteredPotensi.length > 0">
          <v-col v-for="item in filteredPotensi" :key="item.id" cols="12" sm="6" md="4">
            <v-card
              class="potensi-card-v3 overflow-hidden"
              elevation="0"
              @click="openDetail(item)"
            >
              <div class="card-image-section">
                <v-img
                  :src="item.full_url || '/images/default-desa.jpg'"
                  height="220"
                  cover
                  class="img-zoom"
                >
                  <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                      <v-progress-circular
                        indeterminate
                        color="#018c74"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                  <div class="category-badge">
                    <v-icon x-small color="white" class="mr-1">mdi-tag-outline</v-icon>
                    {{ (item.potensi_unggulan || "POTENSI").toUpperCase() }}
                  </div>
                </v-img>
                <div class="scan-line-horizontal"></div>
              </div>

              <v-card-text class="pa-5 content-box">
                <div class="d-flex justify-space-between align-center mb-2">
                  <span class="black--text font-weight-bold letter-spacing-1 text-caption"
                    >#DATA_{{ item.id }}</span
                  >
                  <div class="status-pulse"></div>
                </div>

                <h3 class="black--text text-h6 font-weight-black mb-3 title-truncate">
                  {{ item.nama_desa.toUpperCase() }}
                </h3>

                <p
                  class="black--text text-caption opacity-6 line-clamp-4 mb-4"
                  style="min-height: 60px"
                >
                  {{
                    item.deskripsi ||
                    "Belum ada deskripsi yang diinputkan untuk sektor potensi di wilayah ini."
                  }}
                </p>

                <div class="d-flex align-center pt-3 border-top-thin">
                  <v-icon x-small color="#018c74" class="mr-2">mdi-check-decagram</v-icon>
                  <span class="black--text text-overline opacity-4 font-weight-bold"
                    >SISTEM_TERVERIFIKASI</span
                  >
                  <v-spacer></v-spacer>
                  <v-icon color="#CFA22D" size="20"
                    >mdi-chevron-right-circle-outline</v-icon
                  >
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row v-else class="text-center mt-15">
          <v-col>
            <div class="empty-state-orb mx-auto">
              <v-icon size="80" color="rgba(207, 162, 45, 0.2)"
                >mdi-database-off-outline</v-icon
              >
            </div>
            <div class="black--text opacity-5 mt-6 letter-spacing-4 font-weight-bold">
              BELUM ADA DATA
            </div>
            <v-btn
              outlined
              color="#018c74"
              @click="$router.back()"
              class="mt-8 px-10 rounded-pill black--text font-weight-black"
            >
              KEMBALI KE LIST DESA
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <v-bottom-sheet v-model="modalActive" inset max-width="900">
      <v-sheet class="detail-sheet" color="#002b24">
        <div class="drag-area" @click="modalActive = false">
          <div class="drag-handle mx-auto"></div>
        </div>

        <v-container v-if="selectedDesa" class="pa-6 pa-md-10 pb-15">
          <v-row>
            <v-col cols="12" md="5">
              <v-img
                :src="selectedDesa.full_url || '/images/default-desa.jpg'"
                class="rounded-xl border-gold-glow shadow-premium"
                cover
                height="400"
              ></v-img>
            </v-col>
            <v-col cols="12" md="7" class="d-flex flex-column pl-md-8">
              <div class="d-flex align-center mb-3">
                <v-chip color="#018c74" label small class="font-weight-black mr-3"
                  >IDENTIFIED_DATA</v-chip
                >
                <span class="black--text text-overline"
                  >SECTOR_ID: {{ selectedDesa.id }}</span
                >
              </div>

              <h1 class="black--text text-h3 font-weight-black mb-1">
                {{ selectedDesa.nama_desa.toUpperCase() }}
              </h1>
              <div class="black--text text-h6 font-weight-bold mb-6">
                ASET UTAMA: {{ selectedDesa.potensi_unggulan }}
              </div>

              <v-divider dark class="mb-6 opacity-2"></v-divider>

              <div class="scroll-container pr-4 mb-8">
                <div class="text-overline grey--text mb-4 letter-spacing-2">
                  LAPORAN_DESKRIPTIF
                </div>
                <p
                  class="black--text text-body-1 opacity-8 text-justify"
                  style="line-height: 1.8"
                >
                  {{
                    selectedDesa.deskripsi ||
                    "Sistem belum menerima laporan deskripsi mendalam untuk titik wilayah ini. Informasi lebih lanjut akan segera diperbarui melalui pusat data daerah."
                  }}
                </p>
              </div>

              <v-spacer></v-spacer>

              <v-btn
                v-if="selectedDesa.link"
                block
                x-large
                color="#CFA22D"
                class="mb-4 font-weight-black rounded-lg"
                @click="visitLink(selectedDesa.link)"
              >
                <v-icon left>mdi-earth</v-icon> KUNJUNGI SITUS RESMI
              </v-btn>

              <v-btn
                block
                text
                color="white"
                class="opacity-5"
                @click="modalActive = false"
              >
                TUTUP_DETAIL_INFORMASI
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>
  </v-app>
</template>

<script>
import axios from "axios";
import { getPotensiDesa } from "@/api/androidInitApi";

export default {
  data: () => ({
    search: "",
    allPotensi: [],
    particles: [],
    ctx: null,
    animationId: null,
    modalActive: false,
    selectedDesa: null,
  }),
  computed: {
    filteredPotensi() {
      if (!this.allPotensi) return [];

      const kecId = this.$route.params.id;
      const targetDesa = this.$route.query.desa;
      const query = this.search.toLowerCase().trim();

      return this.allPotensi.filter((p) => {
        const matchKec = p.kecamatan_id == kecId;

        const matchDesa = targetDesa
          ? p.nama_desa.toLowerCase().trim() === targetDesa.toLowerCase().trim()
          : true;

        const matchSearch =
          p.nama_desa.toLowerCase().includes(query) ||
          (p.potensi_unggulan && p.potensi_unggulan.toLowerCase().includes(query));

        return matchKec && matchDesa && matchSearch;
      });
    },
  },
  mounted() {
    this.initParticles();
    this.fetchData();
    window.addEventListener("resize", this.resizeCanvas);
  },
  beforeDestroy() {
    cancelAnimationFrame(this.animationId);
    window.removeEventListener("resize", this.resizeCanvas);
  },
  methods: {
    async fetchData() {
      try {
        this.allPotensi = (await getPotensiDesa()) || [];
      } catch (e) {
        console.error("Data Stream Interrupted:", e);
      }
    },
    openDetail(item) {
      this.selectedDesa = item;
      this.modalActive = true;
    },
    visitLink(url) {
      if (url) {
        const webUrl = url.startsWith("http") ? url : `https://${url}`;
        window.open(webUrl, "_blank");
      }
    },
    initParticles() {
      const canvas = this.$refs.particleCanvas;
      if (!canvas) return;
      this.ctx = canvas.getContext("2d");
      this.resizeCanvas();
      this.particles = Array.from({ length: 45 }, () => ({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        vx: (Math.random() - 0.5) * 0.3,
        vy: (Math.random() - 0.5) * 0.3,
        radius: Math.random() * 2 + 1,
      }));
      this.animate();
    },
    resizeCanvas() {
      const canvas = this.$refs.particleCanvas;
      if (canvas) {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
      }
    },
    animate() {
      if (!this.ctx) return;
      this.ctx.clearRect(
        0,
        0,
        this.$refs.particleCanvas.width,
        this.$refs.particleCanvas.height
      );
      this.particles.forEach((p) => {
        p.x += p.vx;
        p.y += p.vy;
        if (p.x < 0 || p.x > this.$refs.particleCanvas.width) p.vx *= -1;
        if (p.y < 0 || p.y > this.$refs.particleCanvas.height) p.vy *= -1;
        this.ctx.beginPath();
        this.ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
        this.ctx.fillStyle = "rgba(1, 140, 116, 0.4)";
        this.ctx.fill();
      });
      this.animationId = requestAnimationFrame(this.animate);
    },
  },
};
</script>


<style scoped>
:root {
  --bg-teal: #018c74;
  --bg-teal-dark: #016b62;
  --bg-teal-light: #8bcdc6;
  --bone-white: #f5f5f5;
  --bone-light: #fafafa;
  --text-primary: #2e2e2e;
  --accent-gold: #ffa726;
  --accent-teal: #018c74;
}

.futuristic-app {
  background: #f6f9f9 !important;
}



.potensi-card-v3 {
  background: #f5f5f5 !important;
  backdrop-filter: blur(15px);
  border: 1px solid rgba(45, 138, 122, 0.25) !important;
  border-radius: 20px !important;
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  cursor: pointer;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
}
.potensi-card-v3:hover {
  transform: translateY(-10px);
  border-color: var(--accent-teal) !important;
  background: rgba(45, 138, 122, 0.08) !important;
  box-shadow: 0 24px 60px rgba(38, 166, 154, 0.25);
}

.category-badge {
  position: absolute;
  bottom: 15px;
  left: 15px;
  background: rgba(45, 138, 122, 0.9);
  padding: 6px 16px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 800;
  color: var(--bone-white);
  backdrop-filter: blur(8px);
  box-shadow: 0 4px 16px rgba(38, 166, 154, 0.3);
}


.status-pulse {
  width: 8px;
  height: 8px;
  background: var(--accent-teal);
  border-radius: 50%;
  box-shadow: 0 0 12px var(--accent-teal);
  animation: pulse 1.5s infinite;
}
@keyframes pulse {
  0% {
    opacity: 0.4;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.4;
  }
}

.detail-sheet {
  border-top: 4px solid var(--accent-teal) !important;
  border-radius: 40px 40px 0 0 !important;
  background: #f5f5f5 !important;
  box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.2);
}
.drag-area {
  width: 100%;
  padding: 25px 0;
  cursor: pointer;
}
.drag-handle {
  width: 60px;
  height: 5px;
  background: rgba(45, 138, 122, 0.3);
  border-radius: 10px;
}
.scroll-container {
  max-height: 250px;
  overflow-y: auto;
}
.scroll-container::-webkit-scrollbar {
  width: 4px;
}
.scroll-container::-webkit-scrollbar-thumb {
  background: var(--accent-teal);
  border-radius: 10px;
}

.black--text {
  color: var(--accent-gold) !important;
}
.letter-spacing-2 {
  letter-spacing: 2px;
}
.letter-spacing-4 {
  letter-spacing: 4px;
}
.line-clamp-4 {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.glass-alert {
  background: rgba(45, 138, 122, 0.12) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(45, 138, 122, 0.35) !important;
  border-radius: 15px !important;
}
.border-gold-glow {
  border: 2px solid var(--accent-gold) !important;
  box-shadow: 0 0 20px rgba(255, 167, 38, 0.3);
}

@media (max-width: 768px) {
  .potensi-card-v3:hover {
    transform: translateY(-6px);
  }
  .category-badge {
    bottom: 12px;
    left: 12px;
    padding: 4px 12px;
    font-size: 10px;
  }}


.futuristic-app {
  background: #f6f9f9 !important;
}

.main-area {
  background: radial-gradient(circle at 90% 5%, rgba(1, 140, 116, 0.035), transparent 25%),
    #f6f9f9;
}

.layanan-header {
  background: rgba(255, 255, 255, 0.94) !important;

  backdrop-filter: blur(18px);

  border-bottom: 1px solid rgba(1, 140, 116, 0.08) !important;

  z-index: 20 !important;
}

.header-inner {
  width: 100%;
  max-width: 1280px;

  margin: 0 auto;

  display: flex;
  align-items: center;
}

.back-btn {
  width: 42px !important;
  height: 42px !important;

  background: #f1f6f5;
  margin-right: 10px;
}

.back-btn:hover {
  background: #e8f5f2;
}

.header-brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.brand-mark {
  width: 40px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 12px;

  background: linear-gradient(135deg, #e4f6f1, #f5fbf9);

  border: 1px solid rgba(1, 140, 116, 0.1);
}

.brand-name {
  font-size: 15px;
  font-weight: 900;
  letter-spacing: 0.5px;
  color: #17423b;
  line-height: 1.1;
}

.brand-name span {
  color: #018c74;
}

.brand-tagline {
  font-size: 9px;
  color: #8a969b;
  margin-top: 3px;
}

.header-info {
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 0;
}

.header-info > div:last-child {
  min-width: 0;
}

.header-info-icon {
  width: 36px;
  height: 36px;

  border-radius: 10px;

  background: #f1faf8;

  display: flex;
  align-items: center;
  justify-content: center;
}

.header-info-title {
  font-size: 12px;
  font-weight: 800;
  color: #34514c;
}

.header-info-subtitle {
  max-width: 260px;

  font-size: 10px;
  color: #929da1;
  margin-top: 1px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-search {
  max-width: 300px;
}

.header-search-wrap {
  min-width: 0;
}

.header-search ::v-deep .v-input__slot,
.cyber-search-dropdown ::v-deep .v-input__slot {
  min-height: 42px !important;

  background: #f1f6f5 !important;

  border: 1px solid rgba(1, 140, 116, 0.12) !important;

  box-shadow: none !important;

  transition: all 0.25s ease;
}

.header-search ::v-deep .v-input__slot:focus-within,
.cyber-search-dropdown ::v-deep .v-input__slot:focus-within {
  background: #ffffff !important;

  border-color: #018c74 !important;
}

.header-search ::v-deep .v-icon,
.cyber-search-dropdown ::v-deep .v-icon {
  color: #018c74;
}

@media (max-width: 600px) {
  .header-inner {
    padding: 0 8px;
  }

  .brand-mark {
    width: 35px;
    height: 35px;
  }

  .brand-name {
    font-size: 12px;
  }

  .brand-tagline {
    font-size: 8px;
  }
}
</style>
